import Add2Calendar from 'add2calendar';
import { initWebinarIndividualYtPlayer } from '../../../snippets/webinar-individual-ytplayer/webinar-individual-ytplayer';
import { openWebinarIndividualVideo } from '../../../snippets/webinar-individual-frame/webinar-individual-frame';
import { sendWebinarsEvent } from '../../../scripts/config/analytics';
import { initWebinarIndividualForm } from '../../../snippets/webinar-individual-form/webinar-individual-form';
import {
  WEBINAR_EVENT_CATEGORY,
  WEBINAR_ACTIONS,
} from '../../../scripts/config/constants';

export const initWebinarsIndividual = () => {
  const isIndividualPage = Boolean(window.location.search);

  if (isIndividualPage) {
    showWebinarById(getWebinarId());
  }

  initIndividualWidgets();

  document
    .querySelectorAll('.js-webinar-individual-frame-open-action')
    .forEach((item) => {
      item.onclick = () => {
        openWebinarIndividualVideo(item.dataset.webinarId);
      };
    });

  window.onReady(() => {
    initWebinarIndividualYtPlayer('.js-webinar-individual-play-action');

    document
      .querySelectorAll('[data-webinar-individual-form]')
      .forEach((form) => {
        initWebinarIndividualForm(
          form.getAttribute('data-webinar-individual-form')
        );
      });
  });
};

function showWebinarById(webinarId) {
  if (webinarId) {
    const activeWebinarEl = document.querySelector(
      `[data-webinar-id="${webinarId}"]`
    );
    const individualWebinarsEl = document.querySelector(
      '[data-individual-list]'
    );
    const individualPlaceholderEl = document.querySelector(
      '[data-visible-placeholder]'
    );

    if (activeWebinarEl) {
      activeWebinarEl.setAttribute('data-visible-item', 'true');
      individualWebinarsEl.setAttribute('data-individual-list', 'false');

      individualPlaceholderEl.setAttribute('data-visible-placeholder', 'false');
    } else {
      individualWebinarsEl.setAttribute('data-individual-list', 'true');

      individualPlaceholderEl.setAttribute('data-visible-placeholder', 'true');

      individualPlaceholderEl.querySelector(
        '[data-placeholder-text]'
      ).textContent = `404: Webinar "id=${webinarId}" was not found.`;
    }
  }
}

function initIndividualWidgets() {
  document.querySelectorAll('[data-widget-id]').forEach((element) => {
    const widgetData = element.dataset || null;

    if (widgetData) {
      const addToCalendarsData = {
        title: widgetData.webinarHeader,
        start: new Date(widgetData.start),
        end: new Date(widgetData.end),
        location: '',
        timezone: 'America/Los_Angeles',
        description: '',
        isAllDay: false,
      };

      const singleEvent = new Add2Calendar(addToCalendarsData);
      const widgetSelector = `[data-widget-id="${widgetData.widgetId}"]`;

      singleEvent.createWidget(widgetSelector);

      initAdd2CalendarAnalytics(widgetSelector);
    }
  });
}

window.addEventListener('load', () => {
  initWebinarAnalytics();
});

function getWebinarId() {
  const webinarId = window.location.search.replace(
    /^\?.*webinar_id=|&.*$/g,
    ''
  );

  return webinarId || '';
}

function initWebinarAnalytics() {
  const webinarId = getWebinarId();
  const webinarsIndividualSection = document.querySelector(
    `[data-webinars-individual][data-webinar-id="${webinarId}"]`
  );

  if (!webinarsIndividualSection) {
    return false;
  }

  const isRecordedEventWebinarAttr =
    webinarsIndividualSection &&
    webinarsIndividualSection.getAttribute('data-webinar-passed');
  const isRecordedEvent = isRecordedEventWebinarAttr === 'true';
  const playVideoEl = webinarsIndividualSection.querySelector(
    '[data-play-video-action]'
  );
  const individualForm = webinarsIndividualSection.querySelector(
    '[data-webinar-individual-form]'
  );

  if (webinarsIndividualSection) {
    const categoryEvent = isRecordedEvent
      ? WEBINAR_EVENT_CATEGORY.RECORD
      : WEBINAR_EVENT_CATEGORY.LIVE;

    sendWebinarsEvent(categoryEvent, WEBINAR_ACTIONS.SHOW_DESC, webinarId);
  }

  if (individualForm) {
    initClickToFormAnalytics(individualForm, webinarId, isRecordedEvent);
  }

  if (playVideoEl) {
    playVideoEl.addEventListener('click', () => {
      sendWebinarsEvent(
        WEBINAR_EVENT_CATEGORY.RECORD,
        WEBINAR_ACTIONS.START_WATCHING,
        webinarId
      );
    });
  }

  return false;
}

function initClickToFormAnalytics(form, webinarId, isRecorded) {
  let analyticsDataWereSent = false;

  form.addEventListener('click', (event) => {
    const { target } = event;

    if (!analyticsDataWereSent) {
      if (target.closest('input')) {
        analyticsDataWereSent = true;
        const eventCategory = isRecorded
          ? WEBINAR_EVENT_CATEGORY.RECORD
          : WEBINAR_EVENT_CATEGORY.LIVE;

        sendWebinarsEvent(
          eventCategory,
          WEBINAR_ACTIONS.START_REGISTRATION,
          webinarId
        );
      }
    }
  });
}

function initAdd2CalendarAnalytics(widgetSelector) {
  const CALENDAR = {
    GOOGLE: 'Google',
    ICAL: 'iCal',
    OUTLOOK: 'Outlook',
    YAHOO: 'Yahoo',
  };

  const webinarId = getWebinarId();
  const widgetContainer = document.querySelector(widgetSelector);
  const add2CalendarList = widgetContainer.querySelector('.a2cldr-list');

  if (add2CalendarList) {
    add2CalendarList.addEventListener('click', (event) => {
      const calendarLink = event.target;

      if (calendarLink.href) {
        let calendarType = calendarLink.text;

        if (String(calendarLink.text).toUpperCase().includes('GOOGLE')) {
          calendarType = CALENDAR.GOOGLE;
        } else if (String(calendarLink.text).toUpperCase().includes('ICAL')) {
          calendarType = CALENDAR.ICAL;
        } else if (
          String(calendarLink.text).toUpperCase().includes('OUTLOOK')
        ) {
          calendarType = CALENDAR.OUTLOOK;
        } else if (String(calendarLink.text).toUpperCase().includes('YAHOO')) {
          calendarType = CALENDAR.YAHOO;
        }

        sendWebinarsEvent(
          WEBINAR_EVENT_CATEGORY.LIVE,
          WEBINAR_ACTIONS.ADD_TO_CALENDAR,
          webinarId,
          calendarType
        );
      }
    });
  }
}
